export const SEO_IMAGE_ATTRIBUTES = {
  IMAGE_ALT_PREFIX: '',
  IMAGE_ALT_SUFFIX: 'Online Shopping',
  IMAGE_TITLE_PREFIX: 'Buy',
  IMAGE_TITLE_SUFFIX: 'Online',
};

export const IMAGE_SALE_TIMER_TITLE = 'Sale Starts In';
